import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

const CARDIOLOGY_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY>
> = [
  {
    key: "diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology.diagnosisLabel,
  },
  {
    key: "anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .medicalHistoryLabel,
  },
  {
    key: "allergies",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology.allergyLabel,
  },
  {
    key: "additional_diagnostic_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .furtherDiagnosisLabel,
  },
  {
    key: "physical_status",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .physicalStatusLabel,
  },
  {
    key: "discharge_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .dischargeMedicationsLabel,
  },
  {
    key: "previous_diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .previousDiagnosesLabel,
  },
  {
    key: "social_history",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .socialHistoryLabel,
  },
  {
    key: "therapy_and_course",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .therapyAndCourseLabel,
  },
  {
    key: "ecg",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology.ecgLabel,
  },
];

export function createCardiologyDischargeLetterPdf(
  props: PdfCreatorProps<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY>,
) {
  return createDischargeLetterPdf<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY
  >(props, CARDIOLOGY_FIELD_CONFIG);
}
